import { takeLatest, put, call } from 'redux-saga/effects';

import { findUnidadeMedidaCadastro } from '../service';
import {
  FIND_UNIDADE_MEDIDA_CADASTRO,
  FIND_UNIDADE_MEDIDA_CADASTRO_PENDING,
  FIND_UNIDADE_MEDIDA_CADASTRO_SUCCESS,
  FIND_UNIDADE_MEDIDA_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaFindUnidadeMedidaCadastro(action) {
  yield put({ type: FIND_UNIDADE_MEDIDA_CADASTRO_PENDING, id: action.id })

  try {

    const registro = yield call(findUnidadeMedidaCadastro, action.id);

    yield put({ type: FIND_UNIDADE_MEDIDA_CADASTRO_SUCCESS, registro: registro })

  } catch (error) {

    yield put({ type: FIND_UNIDADE_MEDIDA_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchFindUnidadeMedidaCadastro() {
  yield takeLatest(FIND_UNIDADE_MEDIDA_CADASTRO, sagaFindUnidadeMedidaCadastro)
}
